// extracted by mini-css-extract-plugin
export default {"componentDiv":"EditInterestComponent_componentDiv__wPOaA","componentText":"EditInterestComponent_componentText__h0xgm","icon":"EditInterestComponent_icon__pMgTJ"};